<ng-container *ngIf="attachementFile; else dropTemplate">
    <div class="attachment-file">
        <div class="file-name" (click)="downloadFile(attachementFile)">
            <img class="pdf-icon" src="../../../assets/icons/pdf.svg">
            <p class="file-name">{{attachementFile.name}}</p>
        </div>
        <ng-container *ngIf="returnType == 'viewOnly'; else removeButton">
            <img src="../../../assets/icons/download.svg" class="remove">
        </ng-container>
        <ng-template #removeButton>
            <img src="/assets/icons/trash-2.svg" class="remove">
        </ng-template>
    </div>
</ng-container>
<ng-template #dropTemplate>
    <div class="file-drop-area" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
        <input type="file" class="file-input" (change)="onFileChange($event)" hidden #fileInput />
        <p (click)="fileInput.click()">Drag files here or <span class="upload-link">Upload</span></p>
    </div>
</ng-template>
